var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLeftArrowGoBackQuickshipPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.959561 7.29289C0.569037 7.68342 0.569037 8.31658 0.959561 8.70711L7.32352 15.0711C7.71405 15.4616 8.34721 15.4616 8.73774 15.0711C9.12826 14.6805 9.12826 14.0474 8.73774 13.6569L3.08088 8L8.73774 2.34315C9.12826 1.95262 9.12826 1.31946 8.73774 0.928932C8.34721 0.538408 7.71405 0.538408 7.32352 0.928932L0.959561 7.29289ZM3 7L1.66667 7L1.66667 9L3 9L3 7Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLeftArrowGoBackQuickshipPage);
export default __webpack_public_path__ + "static/media/mobile-left-arrow-go-back-quickship-page.7e11df9743e7706dfe77c25509e579f9.svg";
export { ForwardRef as ReactComponent };